<template>
  <transition name="fadeSlider">
    <div class="slider-wrapper" :style="`background-image: url(${image});`">
      <div
        v-for="(slide, i) in slides"
        v-show="index === i"
        :key="i"
        class="slider-content"
      >
        <Heading v-if="slide.text" type="h2" size="m">{{ slide.text }}</Heading>
        <ul v-if="slide.liItems">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <li v-for="item in slide.liItems" :key="item" v-html="item"></li>
        </ul>
        <div v-if="slide.logos" class="slider-logos">
          <div v-for="(logo, logoInd) in slide.logos" :key="`logo_${logoInd}`">
            <img :src="logo"/>
          </div>
        </div>
        <div v-if="slide.map" class="slider-map">
          <img :src="slide.map"/>
        </div>
        <ul v-if="slide.news" class="news-item">
          <li v-for="(news, ind) in slide.news" :key="ind">
            <a :href="news.url"><Heading type="h5" size="s">{{ news.title }}</Heading></a>
            <p>{{ news.description }}</p>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import Heading from '@/components/Heading';

export default {
  components: {
    Heading,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    slides: {
      type: Array,
      default: () => ([]),
    }
  },
  computed: {
    image () {
      return this.slides && this.slides[this.index].image;
    },
  },
  beforeDestroy () {
    window.clearInterval(this.interval);
  },
}
</script>

<style lang="scss">
.slider-wrapper {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50% 0;
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
}
.slider-content {
  position: absolute;
  left: 30px;
  right: 30px;
  bottom: 40px;
  @media (max-width: 767px) {
    left: 10px;
    right: 10px;
    bottom: 10px;
  }

  h2 {
    color: #fff;
    text-align: center;
    padding: 0 0 40px;
    @media (max-width: 767px) {
      padding: 0;
      font-size: 26px;
    }
  }

  ul {
    display: flex;
    padding: 5px 40px 60px;
    justify-content: space-between;
    list-style: none;
    @media (max-width: 767px) {
      padding: 0;
      margin: 0 0 10px;
      flex-wrap: wrap;
    }
    li {
      text-align: center;
      color: #fff;
      @media (max-width: 767px) {
        font-size: 11px;
        line-height: 1;
      }

      a {
        color: #fff;
      }
    }

    &.news-item {
      flex-wrap: wrap;
      padding:  5px 0 30px;
      @media (max-width: 767px) {
        padding: 0;
      }

      li {
        flex: 1 25%;
        padding: 0 5px 30px;
        @media (max-width: 767px) {
          padding: 0 5px 5px;
        }
      }
    }
  }
}
.slider-map {
  text-align: center;
  width: 100%;
  img {
    max-width: 90%;
  }
}
.slider-logos {
  background: #fff;
  display: flex;
  align-items: center;
  padding: 5px 40px;
  border-radius: 50px;
  justify-content: space-between;
  @media (max-width: 767px) {
    padding: 5px 20px;
  }
  > div {
    flex: 1 20%;
    text-align: center;
    img {
      max-width: 90%;
    }
  }
}
.fadeSlider-enter-active {
  transition: opacity 2s;
}
.fadeSlider-leave-active {
  transition: opacity 1s;
}
.fadeSlider-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Slider.vue?705474dc